// src/utils/disableShortcuts.js
export const disableKeyboardShortcuts = () => {
  const handler = (event) => {
    if (event.ctrlKey && (event.key.toLowerCase() === "e" || event.key.toLowerCase() === "l")) {
      event.preventDefault();
      console.log(`Blocked Ctrl + ${event.key.toUpperCase()}`);
    }
  };

  window.addEventListener("keydown", handler);

  // Optional cleanup if ever needed
  return () => window.removeEventListener("keydown", handler);
};
